(function () {
  function getFormFields(form) {
    var fields = {};
    var hasData = false;

    form.querySelectorAll('input, select, textarea').forEach(function (input) {
      if (input.type === 'password') return;
      if (input.name === 'h-captcha-response') return;

      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;

      var name = input.id || input.name;
      if (!name) return;

      var value = (input.value || '').trim();

      if (value !== '') {
        hasData = true;
      }

      fields[name] = value;
    });

    return {
      fields: fields,
      hasData: hasData
    };
  }

  function getFormMeta(form, embedEl) {
    var formRoot = embedEl.closest('[data-form-root="true"]');

    return {
      form_id: formRoot?.dataset?.formsId || formRoot?.id || form?.id || null,
      form_container_id: formRoot?.id || null,
      form_embed_id: embedEl?.id || null,
      form_internal_id: form?.id || null,
      form_name: embedEl?.shadowRoot?.querySelector('h2')?.textContent?.trim() || null
    };
  }

  function isFormValid(form) {
    var invalidFields = form.querySelectorAll('[aria-invalid="true"]');

    if (invalidFields.length > 0) {
      var invalidNames = Array.from(invalidFields).map(function (field) {
        return field.id || field.name || 'unknown';
      });

      console.log('[THEME] ❌ Campos inválidos:', invalidNames);
      return false;
    }

    var errorOutputs = form.querySelectorAll('output[role="alert"]');

    var hasVisibleErrors = Array.from(errorOutputs).some(function (output) {
      return output.textContent.trim() !== '';
    });

    if (hasVisibleErrors) {
      console.log('[THEME] ❌ Errores visibles en el formulario');
      return false;
    }

    var emailInput = form.querySelector('input[type="email"], input[inputmode="email"]');

    if (emailInput) {
      var emailVal = emailInput.value.trim();
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailVal === '' || !emailRegex.test(emailVal)) {
        console.log('[THEME] ❌ Email inválido o vacío:', emailVal);
        return false;
      }
    }

    var result = getFormFields(form);

    if (!result.hasData) {
      console.log('[THEME] ❌ Formulario sin datos');
      return false;
    }

    return true;
  }

  function publishFormEvent(form, embedEl) {
    setTimeout(function () {
      if (!isFormValid(form)) return;

      var result = getFormFields(form);
      var formMeta = getFormMeta(form, embedEl);

      var eventData = {
        event: 'shopify_form_submitted',
        form_id: formMeta.form_id,
        form_container_id: formMeta.form_container_id,
        form_embed_id: formMeta.form_embed_id,
        form_internal_id: formMeta.form_internal_id,
        form_name: formMeta.form_name,
        form_type: 'shopify_forms',
        form_field_names: Object.keys(result.fields),
        page_location: window.location.href,
        page_title: document.title,
        timestamp: new Date().toISOString()
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);

      console.log('[THEME] ✅ Evento enviado al dataLayer:', eventData);

      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish('blaureka:shopify_form_submitted', {
          form_id: formMeta.form_id,
          form_container_id: formMeta.form_container_id,
          form_embed_id: formMeta.form_embed_id,
          form_internal_id: formMeta.form_internal_id,
          form_type: 'shopify_forms',
          form_field_names: Object.keys(result.fields),
          page_location: window.location.href
        });
      }
    }, 100);
  }

  function attachShadowListeners() {
    var embeds = document.querySelectorAll('shopify-forms-embed');

    embeds.forEach(function (embedEl) {
      if (!embedEl.shadowRoot) return;
      if (embedEl.dataset.formListenerAttached === 'true') return;

      embedEl.dataset.formListenerAttached = 'true';

      embedEl.shadowRoot.addEventListener(
        'submit',
        function (e) {
          var form = e.target;

          if (!form || form.tagName !== 'FORM') return;

          console.log('[THEME] 🔔 Submit detectado en Shadow DOM');
          publishFormEvent(form, embedEl);
        },
        true
      );

      console.log('[THEME] ✅ Listener activo en shopify-forms-embed');
    });
  }

  attachShadowListeners();

  var observer = new MutationObserver(function () {
    attachShadowListeners();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();